import { ExportSearchGrouping } from '@aibees/elephant/hooks';
import { useBrowseSearchExports } from '@aibees/elephant/hooks/use-browse-search-exports';
import { useSocketExportChanges } from '@aibees/elephant/hooks/use-socket-export-changes';
import { useQueryStringState } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo, useEffect } from 'react';
import { useSearchListCardStore } from '../../store';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportTableProps as Props } from './types';

export const ExportTable = memo(({ className }: Props) => {
  const { grouping, name, setEmpty, setIsLoading } = useSearchListCardStore();
  useSocketExportChanges();
  const { params } = useQueryStringState();
  const sortValue = `${params.sortField ?? 'created'}:${
    params.sortOrder ?? 'desc'
  }`;

  const browseApi = useBrowseSearchExports({
    size: 10,
    name: name as string,
    grouping: grouping as ExportSearchGrouping,
    sort: sortValue,
  });
  useEffect(() => {
    setEmpty(browseApi.data?.empty);
    setIsLoading(browseApi.isLoading);
  }, [browseApi.data?.empty, browseApi.isLoading, setEmpty, setIsLoading]);

  return (
    <Styled.Wrapper
      className={classnames('ExportTable', className)}
      sx={SX.root}
      config={{
        ...config,
        browseApi: {
          data: browseApi.data?.content.slice(0, 4),
          isLoading: browseApi.isLoading,
        },
      }}
    />
  );
});

ExportTable.displayName = 'ExportTable';
